import { clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs) {
    return twMerge(clsx(inputs));
}

export const INR = (n) => {
    if (n === undefined || n === null || isNaN(n)) return '—';
    try {
        return '₹' + Number(n).toLocaleString('en-IN', { maximumFractionDigits: 0 });
    } catch {
        return '₹' + n;
    }
};

export const shortDate = (iso) => {
    if (!iso) return '';
    try {
        const d = new Date(iso);
        return d.toLocaleString('en-IN', { day: '2-digit', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit' });
    } catch {
        return iso;
    }
};

// Date-only variant (no timestamp) — used in admin lists where the timestamp
// clutters the row (Applications > Created, Customers > Joined, etc.)
export const dateOnly = (iso) => {
    if (!iso) return '';
    try {
        const d = new Date(iso);
        return d.toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric' });
    } catch {
        return iso;
    }
};


/**
 * Official UPPOWER Solar system cost slabs (as per public rate chart).
 * 1kW is priced slightly higher per-kW (₹65k) because installation overheads
 * don't scale linearly at the smallest size. 2kW onwards uses standard bulk
 * pricing that averages ₹60k/kW.
 */
export const SYSTEM_COST_SLABS = [
    { kw: 1, cost: 65000 },
    { kw: 2, cost: 130000 },
    { kw: 3, cost: 180000 },
    { kw: 4, cost: 240000 },
    { kw: 5, cost: 300000 },
    { kw: 6, cost: 360000 },
    { kw: 7, cost: 420000 },
    { kw: 8, cost: 480000 },
    { kw: 9, cost: 540000 },
    { kw: 10, cost: 600000 },
];

/**
 * Returns the approximate installed system cost for a given capacity in kW,
 * following the SYSTEM_COST_SLABS table. Handles decimal capacities from the
 * homepage slider by linear-interpolating between the two nearest slabs.
 */
export function systemCostForKw(kw) {
    const n = Number(kw);
    if (!n || n <= 0) return 0;
    const table = SYSTEM_COST_SLABS;
    // Exact slab match
    const hit = table.find(r => r.kw === n);
    if (hit) return hit.cost;
    // Below smallest slab — pro-rate the 1kW rate
    if (n < table[0].kw) return Math.round((table[0].cost / table[0].kw) * n);
    // Above largest slab — extend at the last slab's per-kW rate
    const last = table[table.length - 1];
    if (n > last.kw) return Math.round((last.cost / last.kw) * n);
    // Interpolate between slabs
    for (let i = 0; i < table.length - 1; i++) {
        const a = table[i], b = table[i + 1];
        if (n > a.kw && n < b.kw) {
            const t = (n - a.kw) / (b.kw - a.kw);
            return Math.round(a.cost + t * (b.cost - a.cost));
        }
    }
    return Math.round(60000 * n);
}
